<template>
  <button
    class="button flex h-full w-full flex-col items-start justify-center gap-2 pl-10 font-golos"
    :class="{
      'flex-col-reverse': locale === AppLocale.KK,
    }"
    type="button"
  >
    <span class="cashback-text text-[32px] font-extrabold">
      {{ t('banner.cashback', { maxPercent: MAX_CASHBACK_PERCENT }) }}
    </span>
    <span class="cashback-text text-2xl font-semibold">
      {{ t('banner.inSuperApp') }}
    </span>
  </button>
</template>

<script setup lang="ts">
  import { injectAppContext } from '@shared/app-context';
  import { AppLocale } from '@shared/i18n';
  import { MAX_CASHBACK_PERCENT } from '@entities/freedom-cashback';
  import { useMainPageLocales } from '../locales';

  const { locale } = injectAppContext();
  const { t } = useMainPageLocales();
</script>

<style scoped>
  .button {
    background-image: url('./assets/banner-background.webp');
    background-repeat: no-repeat;
    background-size: contain;
  }

  .cashback-text {
    background: linear-gradient(262.23deg, #01d58a -1.12%, #006fc2 101.31%);
    color: transparent;
    background-clip: text;
    -webkit-background-clip: text;
  }
</style>
